import apiClient from '@/lib/api';
import { User, UserResponse, UserFilters } from '@/types/user';

export const usersApi = {
  /**
   * Get user by ID.
   */
  getById: (userId: string): Promise<User> => {
    return apiClient.get(`/api/users/${userId}`).then(res => res.data.data || res.data);
  },

  /**
   * Update user profile.
   */
  update: (userId: string, data: Partial<User>): Promise<UserResponse> => {
    return apiClient.put(`/api/users/${userId}`, data).then(res => res.data);
  },

  /**
   * List users (admin only, with optional filters).
   */
  list: (filters?: UserFilters): Promise<User[]> => {
    return apiClient.get('/api/users', { params: filters }).then(res => res.data.data || res.data);
  },
};
